<div class="col-md-10 offset-md-1">
    <h1 class="col-md-12"
        style="text-align: center; color: rgb(17,80,114); font-size: 30px; font-weight:700; padding-top: 40px; padding-bottom:20px">
        {{pageTitle}}</h1>
    <p *ngIf="!auth.isLoggedIn"
       class="col-md-12"
       style="text-align: left; color: rgb(0,0,0); font-size: 20px; padding-top: 10px; padding-bottom: 30px">Welcome to
        the North Carolina Business & Occupational License Database. You may need a license to operate a business or
        perform work in North Carolina. Discover the hundreds of business, occupational, and privilege licenses issued
        in North Carolina by searching this site. For more information about licenses in North Carolina, speak with a
        counselor at <a href="https://edpnc.com/start-or-grow-a-business/start-a-business/">EDPNC Small Business
            Advisors</a> by calling <a href="tel:+01-800-228-8443">1 (800) 228-8443</a>.</p>
</div>
<div class="col-md-10 offset-md-1 well">
    <div *ngIf="this.authName">
        <h6>All licenses for {{this.authName}}</h6>
    </div>
    <div *ngIf="this.coordName">
        <h6>All licenses for {{this.coordName}}</h6>
    </div>
    <p></p>
    <div class="input-group">
        <div *ngIf="auth.isLoggedIn && this.enums"><b>Status: </b>
            <select [(ngModel)]="filterActive"
                    style="height: 38px; margin-right:10px;">
                <option value=''>All</option>
                <option *ngFor="let e of filterEnum('active')"
                        value='{{e.key}}'>{{e.value}}</option>
                <option *ngIf="!auth.isCoordinator"
                        value='o'>Occupation needed</option>
                <option *ngIf="!auth.isCoordinator"
                        value='t'>License type needed</option>
                <option value='n'>Licenses issued needed</option>
                <option value='x'>Transfer request</option>
                <option value='z'>Any flag</option>
            </select>
        </div>
        <input type="text"
               class="form-control"
               height="15px"
               aria-label="Type license name or keyword"
               placeholder="Type license name or keyword"
               [(ngModel)]="searchTerms">
        <div *ngIf="auth.isLoggedIn"
             class="pull-right">&nbsp;
            <button class="btn btn-primary btn-ncb-wide"
                    [routerLink]="['/license/0/edit']">New License</button>
        </div>
    </div>
    <p>
    <p></p>
    <div class="tableFixHead"
         [ngStyle]="{'height': auth.isLoggedIn ? '50vh' : '38vh' }">
        <table>
            <thead *ngIf="auth.isLoggedIn">
                <th *ngFor="let col of cols"><a (click)="lh.setOrder(col.name);">
                        <span><i *ngIf="lh.listOrder==col.name"
                               [className]="lh.orderDesc?'fa fa-sort-alpha-desc':'fa fa-sort-alpha-asc'"></i></span>
                        {{col.label}}</a>&nbsp;</th>
            </thead>
            <tbody *ngFor="let license of licenses">
                <tr *ngIf="filterResults(license)">
                    <td>
                        <a [routerLink]="auth.isLoggedIn? ['/license',license.id,'edit'] :  ['/license',license.id]"
                           [ngStyle]="{'color': license.activeStatus && license.activeStatus>=2?'gray':'#0068ec'}"
                           [innerHTML]="license.licTitle | highlight: this.searchTerms"></a>
                    </td>
                    <td *ngIf="auth.isLoggedIn">
                        {{license.licenseUpdated | date: 'MM/dd/yy h:mm a'}}
                    </td>
                    <td *ngIf="auth.isLoggedIn">
                        <span *ngIf="enums && license.activeStatus && license.activeStatus>0">
                            <span [style.color]="getStatusIcon(license.activeStatus).color"
                                  title="{{getEnumVal('active',license.activeStatus)}}"
                                  [className]="'fa fa-'+getStatusIcon(license.activeStatus).icon">&nbsp;
                            </span>
                        </span>
                        <span *ngFor="let l of flagLabels(license.flags)">
                            <span [style.color]="l.color"
                                  title="{{l.tip}}"
                                  [className]="'fa fa-'+l.icon">&nbsp;</span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<pm-footer *ngIf="!auth.isLoggedIn"></pm-footer>